// https://help.fullstory.com/develop-js/137380
function FullstoryUtil(ErrorTracker) {

	function set(key, val) {
		if ( typeof window !== 'object' || ! window.FS ) {
			return;
		}

		var vars = {};
		vars[key] = val;
		FS.setUserVars(vars);
	}

	function setBool(key, val) {
		// key must be camelCase
		return set(key + '_bool', val);
	}

	function setReal(key, val) {
		// key must be camelCase
		return set(key + '_real', val);
	}

	function setStr(key, val) {
		// key must be camelCase
		return set(key + '_str', val);
	}

	function setInt(key, val) {
		// key must be camelCase
		return set(key + '_int', val);
	}

	function setDate(key, val) {
		// key must be camelCase
		// val must be a javascript Date() object
		return set(key + '_date', val);
	}

	function sendEvent(eventName, eventProperties) {
		// https://help.fullstory.com/develop-js/367098-fs-recording-client-api-requirements#Reserved%20Properties
		var RESERVED_KEYS = [
			'uid', 'displayName', 'email', 'acctId', 'website'
		];

		// if eventProperties wasn't passed in, let's just give it a dummy blob
		if (! eventProperties) {
			eventProperties = {};
		}

		// Check no RESERVED_KEYS are used
		RESERVED_KEYS.forEach(function (key) {
			var ohNoYouUsedAForbiddenKey = eventProperties[key];
			if (ohNoYouUsedAForbiddenKey) {
				ErrorTracker.captureMessage('Forbidden key ' + key + ' used, please don\'t do that since it won\'t be included');
				delete eventProperties[key];
			}
		});

		// Check dev is typechecking accordingly
		var REGEX = /_(str|int|real|date|bool)$/;
		var helpUrl = 'https://help.fullstory.com/develop-js/137380#customdata';
		for (var key in eventProperties) {
			var passes = REGEX.test(key);
			if (! passes) {
				ErrorTracker.captureMessage('Forbidden key ' + key + ' you need to type check that boii, more info: ' + helpUrl);
				delete eventProperties[key];
			}
		}

		if ( typeof window !== 'object' || ! window.FS ) {
			console.debug('tried to fire event to fullstory during SSR or FS not loaded');
			return;
		}

		FS.event(eventName, eventProperties);
	}

	function identify(customerId, name, email) {

		if ( typeof window !== 'object' || ! window.FS ) {
			console.debug('tried to identify during SSR or FS not loaded');
			return;
		}

		FS.identify(customerId, {
			displayName: name || '',
			email: email || '',
		});

	}

	function _sendUrlToSentry() {
		var fullstorySessionUrl = typeof window === 'object' && window.FS && window.FS.getCurrentSessionURL();
		if (fullstorySessionUrl) {
			ErrorTracker.setExtraContext({ fullstorySessionUrl: fullstorySessionUrl });
		}
		window.removeEventListener('fsReady', _sendUrlToSentry, false);
	}

	function sendUrlToSentry() {
		if (typeof window !== 'object') return;

		if (window.cj.fsReady) {
			return _sendUrlToSentry();
		}

		window.addEventListener('fsReady', _sendUrlToSentry, false);
	}

	return {
		identify: identify,
		setBool: setBool,
		setReal: setReal,
		setStr: setStr,
		setInt: setInt,
		setDate: setDate,
		sendEvent: sendEvent,
		sendUrlToSentry: sendUrlToSentry,
	};
}


if (typeof require === 'function' && typeof exports !== 'undefined') {
	var ErrorTracker = require('error_tracker');
	module.exports = FullstoryUtil(ErrorTracker);
} else {
	define(['marketplace/components/error_tracker'], FullstoryUtil);
}
